<template>
  <b-tabs class="send-news-tabs" v-model="tabIndex">
    <!-- Render Tabs, supply a unique `key` to each tab -->
    <b-tab
      v-for="item in tabs"
      :key="'dyn-tab-' + item.index"
      :title="'Notícia'"
    >
      <!-- <p>Current Tab Index: {{tabIndex}}</p> -->
      <template #title>
        <b-badge style="margin-right: 6px" variant="warning" v-if="item.isErrata">{{ $t('MANAGE_NEWS_ITEM.Errata') }}</b-badge>
        <span> {{ item.title ? item.title : $t('SEND_NEWS.Publication') }} </span>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="closeTab(item)"
          style="margin-left: 6px; margin-right"
        />
      </template>
      <send-news
        v-if="true"
        :instance="'tab-' + item.index"
        :editData="item.editData"
        :isNew="item.isNew"
        :isEdit="item.isEdit"
        :isCopy="item.isCopy"
        :isErrata="item.isErrata"
        :startTemplate="item.startTemplate"
        :currentTab="item"
        @updated-status-editing="updateStatusEditing"
        @load-news-data="loadNewsData"
        @close="close"
        @update-tab="updateTab"
      ></send-news>
    </b-tab>

    <!-- New Tab Button (Using tabs-end slot) -->
    <template #tabs-end>
      <b-nav-item role="presentation" @click.prevent="newTab"> </b-nav-item>
    </template>

    <!-- Render this if no tabs -->
    <template #empty>
      <div class="text-center text-muted text-no-tabs" v-html="$t('SEND_NEWS.Tabs_Empty')">
      </div>
    </template>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BNavItem, BBadge } from "bootstrap-vue";
import SendNews from "./SendNews.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import store from '@/store';
export default {
  props: {},
  components: {
    BTabs,
    BTab,
    BNavItem,
    SendNews,
    FeatherIcon,
    BBadge
  },
  data() {
    return {
    };
  },
  watch: {
    "tabs.length" (val) {
      if (val > 0) {
        store.dispatch("report/updateTabIndex");
      }
    }
  },
  computed: {
    tabIndex: {
      get: () => {
        return store.state.report.tabIndex;
      },
      set: () => {
        // console.log('set tab index: ', val)
        store.dispatch("report/updateTabIndex");
      }
    },
    tabs() {
      return this.$store.state.report.tabs;
    },
  },
  created() {
    // console.log("tabs: ", this.tabs);
  },
  methods: {
    isCurrentTab(index) {
      return this.tabIndex == index;
    },
    closeTab(val) {
      this.$store.dispatch("report/closeTab", val);
    },
    newTab() {
      this.$store.dispatch("report/newTab", {
        isEdit: false,
        isCopy: false,
        isErrata: false,
        editData: {},
        draftData: {},
      });
    },
    updateStatusEditing(val) {
      this.$emit("updated-status-editing", val);
    },
    loadNewsData(val) {
      this.$emit("load-news-data", val);
    },
    close(val) {
      this.closeTab(val.currentTab);
      this.$emit("close", val.data);
    },
    updateTab() {
      // console.log('updateTab');
      this.$forceUpdate();
    },
  },
};
</script>

<style>
</style>